const email_regex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validateFirstName(fname) {
  if (fname.trim() === "") {
    document.querySelector(".form-control--fname").classList.add("error");
    document.querySelector(".form-control--fname .feedback").textContent =
      "Please enter your first name.";

    return false;
  }

  document.querySelector(".form-control--fname").classList.remove("error");

  return true;
}

export function validateLastName(lname) {
  if (lname.trim() === "") {
    document.querySelector(".form-control--lname").classList.add("error");
    document.querySelector(".form-control--lname .feedback").textContent =
      "Please enter your last name.";

    return false;
  }

  document.querySelector(".form-control--lname").classList.remove("error");

  return true;
}

export function validateEmail(email) {
  if (email.trim() === "") {
    document.querySelector(".form-control--email").classList.add("error");
    document.querySelector(".form-control--email .feedback").textContent =
      "Please enter your email address";

    return false;
  }

  if (email_regex.test(email) === false) {
    document.querySelector(".form-control--email").classList.add("error");
    document.querySelector(".form-control--email .feedback").textContent =
      "Please enter a valid email address";

    return false;
  }

  document.querySelector(".form-control--email").classList.remove("error");

  return true;
}

export function validateMessage(message) {
  if (message.trim() === "") {
    document.querySelector(".form-control--message").classList.add("error");
    document.querySelector(".form-control--message .feedback").textContent =
      "Please enter a message";

    return false;
  }

  document.querySelector(".form-control--message").classList.remove("error");

  return true;
}
